"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** customFormat = (field, value) => formattedValue */
var _default = function _default(_ref) {
  var values = _ref.values,
      array = _ref.array,
      customFormat = _ref.customFormat,
      otherProps = _objectWithoutProperties(_ref, ["values", "array", "customFormat"]);

  if (!values && !array) return;
  if (!values && array) console.warn('Table: use \'values\' instead of deprecated \'array\' prop.');
  var tableValues = values || array;
  return /*#__PURE__*/_react["default"].createElement("table", otherProps, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, _typeof(tableValues[0]) === 'object' ? Object.keys(tableValues[0]).map(function (column, columnIndex) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: columnIndex
    }, column);
  }) : /*#__PURE__*/_react["default"].createElement("th", null, tableValues[0]))), /*#__PURE__*/_react["default"].createElement("tbody", null, tableValues.map(function (row, rowIndex) {
    if (_typeof(row) === 'object') {
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: rowIndex
      }, Object.values(row).map(function (column, columnIndex) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: columnIndex
        }, customFormat ? customFormat(Object.keys(row)[columnIndex], column) : column);
      }));
    } else {
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: rowIndex
      }, /*#__PURE__*/_react["default"].createElement("td", null, row));
    }
  })));
};

exports["default"] = _default;